/** @typedef {import("../types").StateRelatoOcorrencia} StateRelatoOcorrencia */
import { carregarListagemSalva } from "../infrastructure/persistence/listagem.storage";

/**
 * Filtros padrão da listagem (sem seleção).
 */
const filtrosPadrao = {
  placa: null,
  status: null,
  projeto: null,
  cooperado: null,
  tipoOcorrencia: null,
  dataOcorrenciaDe: null,
  dataOcorrenciaAte: null
};

/**
 * @type {StateRelatoOcorrencia}
 */
function estadoInicial() {
  const salvo = carregarListagemSalva();
  return {
    filtros: salvo?.filtros
      ? { ...filtrosPadrao, ...salvo.filtros }
      : { ...filtrosPadrao },
    totalRegistros: 0,
    itensPorPagina: salvo?.itensPorPagina || 5,
    paginaAtual: salvo?.paginaAtual || 1,
    loading: false
  };
}

export default estadoInicial();
